export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'

export const showModal = (modalType, params = {}) => {
  return {
    type: SHOW_MODAL,
    modalType,
    params
  }
}

export const hideModal = (params) => {
  return {
    type: HIDE_MODAL,
    params
  }
}



// WEBPACK FOOTER //
// ./src/modules/redux-modal/redux/modalAction.js